import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
//import { AuthSigninComponent } from './demo/pages/authentication/auth-signin/auth-signin.component';




const routes: Routes = [
  {path: '', 
  redirectTo: 'auth/signin', 
  pathMatch: 'full'
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./demo/pages/authentication/authentication.module').then(m => m.AuthenticationModule)
      }
    ]
  }, 
    {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./demo/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'auto/activo',
        loadChildren: () => import('./demo/pages/autorizacion/activo/activo.module').then(m => m.ActivoModule)
      },   
      {
        path: 'auto/compra',
        loadChildren: () => import('./demo/pages/autorizacion/compra/compra.module').then(m => m.CompraModule)
      },  
      {
        path: 'auto/conta',
        loadChildren: () => import('./demo/pages/autorizacion/conta/conta.module').then(m => m.ContaModule)
      },  
      {
        path: 'auto/credito',
        loadChildren: () => import('./demo/pages/autorizacion/credito/credito.module').then(m => m.CreditoModule)
      },       
      {
        path: 'auto/cxc',
        loadChildren: () => import('./demo/pages/autorizacion/cxc/cxc.module').then(m => m.CxcModule)
      },
      {
        path: 'auto/cxp',
        loadChildren: () => import('./demo/pages/autorizacion/cxp/cxp.module').then(m => m.CxpModule)
      },
      {
        path: 'auto/dinero',
        loadChildren: () => import('./demo/pages/autorizacion/dinero/dinero.module').then(m => m.DineroModule)
      },      
      {
        path: 'auto/gasto',
        loadChildren: () => import('./demo/pages/autorizacion/gasto/gasto.module').then(m => m.GastoModule)
      },
      {
        path: 'auto/nomina',
        loadChildren: () => import('./demo/pages/autorizacion/nomina/nomina.module').then(m => m.NominaModule)
      },
      {
        path: 'feic',
        loadChildren: () => import('./demo/pages/feic/feic.module').then(m => m.FeicModule)
      }    

    ]
  }


];

@NgModule({

  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
